import { Link } from 'react-router-dom';
import type { CSSProperties, MouseEvent } from 'react';
import { informes } from './informes-registry';

export default function InformesIndex() {
  const handleEnter = (e: MouseEvent<HTMLAnchorElement>) => {
    e.currentTarget.style.borderLeftColor = '#1d4ed8';
    e.currentTarget.style.transform = 'translateX(2px)';
  };
  const handleLeave = (e: MouseEvent<HTMLAnchorElement>) => {
    e.currentTarget.style.borderLeftColor = '#3b82f6';
    e.currentTarget.style.transform = 'translateX(0)';
  };

  return (
    <div style={{ padding: '32px 40px', maxWidth: 920, margin: '0 auto' }}>
      <h1 style={{ fontSize: 26, fontWeight: 700, color: '#0f172a', margin: 0 }}>Informes</h1>
      <p style={{ color: '#64748b', fontSize: 14, marginTop: 4, marginBottom: 24 }}>
        Cuadros de mando y análisis del equipo.
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {informes.map((informe) => (
          <Link
            key={informe.id}
            to={informe.ruta}
            style={card}
            onMouseEnter={handleEnter}
            onMouseLeave={handleLeave}
          >
            <div style={{ fontSize: 16, fontWeight: 700, color: '#0f172a', marginBottom: 4 }}>
              {informe.nombre}
            </div>
            <div style={{ fontSize: 13, color: '#64748b' }}>{informe.descripcion}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}

const card: CSSProperties = {
  display: 'block',
  background: '#fff',
  border: '1px solid #e2e8f0',
  borderRadius: 12,
  padding: '18px 22px',
  textDecoration: 'none',
  borderLeft: '4px solid #3b82f6',
  transition: 'all .12s ease',
};
